









import { Component, Mixins, Model, Prop, Emit } from "vue-property-decorator";

@Component({
})
export default class Separator extends Mixins() {
  @Model("input")
  value: number;

  @Prop({ default: false })
  isVertical: boolean;

  @Prop({ default: 7 })
  width: number;

  data(): any {
    return {
      trackingSource: 0,
      isTracking: false,
    };
  }
  trackingSource: number;
  isTracking: boolean;

  get separatorStyle(): any {
    const widthAsString = this.width + "px";
    const lengthAsString = "100%";
    return {
      width: this.isVertical ? lengthAsString : widthAsString,
      height: !this.isVertical ? lengthAsString : widthAsString,
      cursor: this.isVertical ? "row-resize" : "col-resize",
    };
  }

  getClientLength(): number { // 算出プロパティでは値が更新されない
    const tracker = this.$refs.tracker as Element;
    return this.isVertical
      ? tracker.clientHeight
      : tracker.clientWidth;
  }

  onMouseDown(e: MouseEvent): void {
    e.preventDefault(); // 文字選択防止のため通常動作をキャンセル
    this.trackingSource = this.value - this.getTrackingOffset(e);
    this.isTracking = true;
  }

  onMouseMove(e: MouseEvent): void {
    this.isTracking = (e.buttons !== 0);  // イベントが発生しない場合を考慮しボタン状態で終了判定する
    if (this.isTracking) {
      this.input(Math.max(Math.min(this.trackingSource + this.getTrackingOffset(e), this.getClientLength()), 0));
    }
  }

  getTrackingOffset(e: MouseEvent): number {
    return this.isVertical
      ? e.pageY
      : e.pageX;
  }

  @Emit()
  input(value: number): void {}
}
